import { render } from "./EliminaOrigen.vue?vue&type=template&id=1342f11c&scoped=true"
import script from "./EliminaOrigen.vue?vue&type=script&lang=js"
export * from "./EliminaOrigen.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EliminaOrigen.vue?vue&type=style&index=1&id=1342f11c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1342f11c"]])

export default __exports__